import { useField } from 'formik'
import { motion } from 'framer-motion'
import React from 'react'
import ErrorIcon from '../icons/ErrorIcon'

const FormDoubleTextInput = ({ fields }) => {
  const [
    { value: value1 },
    { error: error1, touched: touched1 },
    { setValue: setValue1 },
  ] = useField(fields[0].handle)
  const value1NotEmpty = `${value1}`.length > 0
  const [
    { value: value2 },
    { error: error2, touched: touched2 },
    { setValue: setValue2 },
  ] = useField(fields[1].handle)
  const value2NotEmpty = `${value2}`.length > 0

  const className1 =
    fields[0].containerAttributes?.find(att => att.label === 'className')
      ?.value || 'w-6/12'
  const className2 =
    fields[1].containerAttributes?.find(att => att.label === 'className')
      ?.value || 'w-6/12'

  return (
    <div className="flex mb-8">
      <div className="flex items-center w-full">
        <div className={`relative flex pr-2 md:pr-4 ${className1}`}>
          <div className="relative flex w-full">
            <motion.label
              className="absolute z-0 inline-flex px-1 pointer-events-none left-2.5 top-[11px]"
              style={{
                backgroundColor: value1NotEmpty ? '#F5F5F5' : 'transparent',
                fontSize: value1NotEmpty ? '10px' : '16px',
              }}
              animate={{
                y: value1NotEmpty ? -18 : 0,
              }}
              transition={{ type: 'ease' }}
            >
              {fields[0].name}
              {fields[0].required ? '*' : ''}
            </motion.label>

            <input
              id={fields[0].handle}
              name={fields[0].handle}
              className={`w-full px-3 bg-transparent border rounded ${
                error1 && touched1 ? 'border-red' : 'border-gray-5'
              } h-11 focus:border-black focus:outline-none focus:ring-1 focus:ring-black`}
              value={value1}
              onChange={e => setValue1(e.target.value)}
            />
            {error1 && touched1 && (
              <ErrorIcon className="absolute z-20 top-1.5  right-2" />
            )}
          </div>
        </div>

        <div className={`relative flex pl-2 md:pl-4 ${className2}`}>
          <div className="relative flex w-full">
            <motion.label
              className="absolute z-0 inline-flex px-1 pointer-events-none left-2.5 top-[11px]"
              style={{
                backgroundColor: value2NotEmpty ? '#F5F5F5' : 'transparent',
                fontSize: value2NotEmpty ? '10px' : '16px',
              }}
              animate={{
                y: value2NotEmpty ? -18 : 0,
              }}
              transition={{ type: 'ease' }}
            >
              {fields[1].name}
              {fields[1].required ? '*' : ''}
            </motion.label>

            <input
              id={fields[1].handle}
              name={fields[1].handle}
              className={`w-full px-3 bg-transparent border rounded ${
                error2 && touched2 ? 'border-red' : 'border-gray-5'
              } h-11 focus:border-black focus:outline-none focus:ring-1 focus:ring-black`}
              value={value2}
              onChange={e => setValue2(e.target.value)}
            />
            {error2 && touched2 && (
              <ErrorIcon className="absolute z-20 top-1.5  right-2" />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormDoubleTextInput
